import React from "react"
import handleViewport from "react-in-viewport"


function Skillbar(props) {
	const { skill, inViewport, forwardedRef } = props
	const { name, color, level } = skill

	return (
		<div className="skillbar" ref={forwardedRef}>
			<div className="skillbar_title">
				{name.toUpperCase()}
				<div className="skillbar_number">{level}%</div>
			</div>
			<div
				className="skillbar_bar"
				style={{ width: inViewport ? level + "%" : 0, backgroundColor: color }}
			></div>
		</div>
	)
}

export default handleViewport(Skillbar)